module.exports = __webpack_public_path__ + "img/item_CommIllustration_04c.f1ba988a.jpeg";